import { createSelector } from "reselect";
import { IStoreProvider } from "../../store/models/slots/typing/slot.interface";
import { RootState } from "../../store/rootStore";

interface ISlotsSelector {
  providers: IStoreProvider[];
}

const selectRawData = (state: RootState) => state.slots.providers;

export const ProviderSelector = (
  section: "slots" | "main" | "live" | "crash"
) =>
  createSelector(selectRawData, (providers) => {
    if (providers.length === 0) {
      return {
        providers: [],
      };
    }
    const filteredProvider = providers.filter(
      (provider) => provider.section === section
    )[0];
    if (!filteredProvider) {
      return {
        providers: [],
      };
    }
    return {
      providers: filteredProvider.providers,
    } as ISlotsSelector;
  });
